import { useMemo } from 'react';

import { getReasonText } from 'modules/common/entityActions';

import { ViewerAccess } from '../hostContracts/access';
import { EditLock } from '../hostContracts/editLocks';
import { getPartEditAvailability } from '../partEditPolicy';

/**
 * The part edit policy for the viewer.
 */
export const useViewerPartEditability = ({
  access,
  partLock,
  collaborationLock,
}: {
  access: ViewerAccess;
  partLock: EditLock;
  collaborationLock: EditLock;
}): {
  canEdit: boolean;
  disabledReason: string | undefined;
} => {
  return useMemo(() => {
    const availability = getPartEditAvailability(access, {
      partLock,
      collaborationLock,
    });
    return availability.status === 'enabled'
      ? { canEdit: true, disabledReason: undefined }
      : {
          canEdit: false,
          disabledReason: getReasonText(availability.reason),
        };
  }, [access, partLock, collaborationLock]);
};
